$(document).on("ready", () => {
    const Shop = new Boutique();
    let criteriasChangeTimeout;
    let criteriasObjects = {};

    const $body = $('body');

    $("[data-kzam-multiselect-options]").each((i, criteria) => {
        let $criteria = $(criteria);
        let KzMS = $criteria.KzamMultiselect();
        $criteria.data("kzam-multi-select", KzMS);
        criteriasObjects[i] = KzMS;
        let bDisplayLoadingAnimation = false;

        KzMS.KzamMultiselect("onChange", () => {
            clearTimeout(criteriasChangeTimeout);
            criteriasChangeTimeout = setTimeout(() =>
            {
                let $countResult = $("#shop_criterias_apply_button_count");
                let $resetButton = $("#shop_criterias_reset_button");
                let $applyButton = $("#shop_criterias_apply_button");
                let $checksum = $("#shop_criterias_loaded_state_checksum");

                // $countResult.text("");
                // $countResult.append($("<img>").attr("src", "css/images/ui/DualRing-1s-34px.gif").css({"width": "14px", "height": "14px"}));


                let criterias_map = [];
                for( let indexCo in criteriasObjects )
                {
                    let criteriaObject = criteriasObjects[indexCo];
                    criterias_map.push(criteriaObject.KzamMultiselect("getValuesMap"));
                    // criteriaObject.KzamMultiselect("setLoading", true);
                }

                // let newStateCheckSum = SubtleCrypto.digest("SHA-256", criterias_map);
                let newStateCheckSum = sha256(JSON.stringify(criterias_map));
               if( newStateCheckSum === $checksum.val() )
               {
                   $applyButton.prop("disabled", true);
                   $countResult.text(0);
               }
               else
               {
                   let $pageRayonHiddenDatas = $("#page_rayon_hidden_datas"),
                       sRdsJSON = $pageRayonHiddenDatas.find("[name='rds']").val();

                   // $("#boutique_dynamic_criterias_block").startLoading();
                   if( bDisplayLoadingAnimation === true )
                   {
                       for( let indexCo in criteriasObjects )
                       {
                           let criteriaObject = criteriasObjects[indexCo];
                           criteriaObject.KzamMultiselect("setLoading", true);
                       }
                   }


                   Shop.getPreviewCriterias({
                       "rds": JSON.parse(sRdsJSON),
                       "criterias_map": criterias_map,
                       "done": xml => {
                           let response = xmlResponse2Json( xml );
                           if( response.erreur.code === 0 )
                           {
                               let data = response.data;

                               $countResult.text(data.count);
                               $applyButton.prop("disabled", true);

                               //ON ACTIVE LE BOUTON APPLY SI LA RECHERCHE A DES RESULTATS
                               if( data.hasOwnProperty("count") && data.count > 0 )
                               {
                                   $applyButton.prop("disabled", false);
                               }

                               if( data.hasOwnProperty("availability_map") )
                               {
                                   let availability_map = JSON.parse(data.availability_map);
                                   availability_map.forEach( criteria =>
                                   {
                                       Object.keys(criteria).forEach(criteria_value_id =>
                                       {
                                           let enabled = !!criteria[criteria_value_id];
                                           let $matchingCheckbox = $("input:checkbox[name^='shop_product_filter_criteria_'][value='"+ criteria_value_id +"']");
                                           if( $matchingCheckbox.length === 1 && $matchingCheckbox.prop("disabled") === enabled )
                                           {
                                               $matchingCheckbox.prop("disabled", !enabled);
                                               $matchingCheckbox.parent().find(".kzam_multiselect__label-text").css("opacity", (enabled ? 1 : 0.6));
                                           }
                                       });
                                   });
                               }

                               // KzMS.KzamMultiselect("setLoading", false);
                               if( bDisplayLoadingAnimation === true )
                               {
                                   for( let indexCo in criteriasObjects )
                                   {
                                       let criteriaObject = criteriasObjects[indexCo];
                                       criteriaObject.KzamMultiselect("setLoading", false);
                                   }
                               }

                           }

                           /*for( let indexCo in criteriasObjects )
                           {
                               let criteriaObject = criteriasObjects[indexCo];
                               criteriaObject.KzamMultiselect("setLoading", false);
                           }*/

                           // $("#boutique_dynamic_criterias_block").stopLoading();
                       }
                   });
               }
            }, 500);
        });


    });

    $body.on("click", "#shop_criterias_apply_button", function() {
       $(this).trigger("kz:apply");
    });

    $body.on("kz:apply", "#shop_criterias_apply_button", () =>
    {
        let url = window.location.href,
           $rayonParams = $("#boutique_rayon_page_content_rayon_params");
        if( $rayonParams.length === 1 )
        {
            var rayonParams = JSON.parse($rayonParams.val());
            if( rayonParams.hasOwnProperty("url_p1") && rayonParams.url_p1.length > 0 )
            {
                url = rayonParams.url_p1;
            }
        }

        let $form = $("<form>").attr("action", url).attr("method", "post");
        $body.append($form);

        for( let indexCo in criteriasObjects ) {
            let criteriaObject = criteriasObjects[indexCo];
            let $input = $("<input>").attr("type", "hidden").val(criteriaObject.KzamMultiselect("getValue")).attr("name", "criterias[]");
            $form.append($input);

        }
        $form.submit();
    });
    //RESET BUTTON
    $body.on("click", "#shop_criterias_reset_button", () => {
        for( let indexCo in criteriasObjects ) {
            let criteriaObject = criteriasObjects[indexCo];
            criteriaObject.KzamMultiselect("reset");
        }
        $("#shop_criterias_apply_button").trigger("kz:apply");
    });


});
